export default __webpack_public_path__ + "static/culture-1-8812c37d874f3970873216de59cf9d72.jpg";